import { Checkbox, Collapse, FormControlLabel, FormGroup, Switch, Typography } from '@material-ui/core'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import Icon from '@mdi/react'
import React, { useEffect, useState } from 'react'


const icons: { [key: number]: string } = {
  1: "/vitrin/icons/electronic.svg",
  2: "/vitrin/icons/poshak.svg",
  3: "/vitrin/icons/arayeshi.svg",
  4: "/vitrin/icons/varzeshi.svg",
  5: "/vitrin/icons/khodro.svg",
  6: "/vitrin/icons/ashpazkhane.svg",
}

const ProductSearch = (props: any) => {
  const [filters, setFilters] = useState({
    start: "",
    end: ""
  })
  const [openList, setOpenList] = useState(null)

  const handleChange = (e: any) => {
    const name = e.target.name
    const value = e.target.value

    setFilters(fil => {
      return {
        ...fil,
        [name]: value
      }
    })
  }

  const search = () => {
    let query = {};
    if (filters.start) {
      query['price.greaterThanOrEqual'] = filters.start
    }
    if (filters.end) {
      query['price.lessThanOrEqual'] = filters.end
    }

    props.onSearch(query)
  }

  const handleOpenList = (type: string) => {
    openList === type ? setOpenList(null) : setOpenList(type)
  }
  return (
    <div className='px-5'>
      <h3>دسته‌بندی: </h3>
      <div className='mt-3 d-flex'>
        <img src={icons[props.cat?.id]} alt={props.cat?.name} className="ml-2" />
        <p className='text-lg text-normal'>{props.cat?.name}</p>
      </div>
      <hr className='hr' />
      <h4>قیمت</h4>
      <div className='d-flex'>
        <label className='ml-1' htmlFor="start">از</label>
        <input className='input' value={filters.start} name="start" placeholder='تومان' onChange={handleChange} />
      </div>
      <div className='d-flex mt-3'>
        <label className='ml-1' htmlFor="start">تا</label>
        <input className='input' value={filters.end} name="end" placeholder='تومان' onChange={handleChange} />
      </div>
      <div className='mt-3 mb-3'>
        <button className='btn-secondary w-100' onClick={search}>جستجو</button>
      </div>
      <hr className='hr' />
      <div className="d-flex justify-content-between mt-3" onClick={() => handleOpenList("type")}>
        <Typography>نوع</Typography>
        {openList === "type" ? (
          <Icon path={mdiChevronUp} size={1} />
        ) : (
          <Icon path={mdiChevronDown} size={1} />
        )}
      </div>
      <Collapse
        in={openList === "type"}
        timeout="auto"
        unmountOnExit
        className='mt-3 mb-3'
      >
        <FormGroup>
          <FormControlLabel control={<Checkbox />} label="غذای سگ" />
          <FormControlLabel control={<Checkbox />} label="غذای گربه" />
          <FormControlLabel control={<Checkbox />} label="غذای آبزیان" />
        </FormGroup>
      </Collapse>
      <hr className='hr' />
      <div className="d-flex justify-content-between mt-3" onClick={() => handleOpenList("brand")}>
        <Typography>برند</Typography>
        {openList === "brand" ? (
          <Icon path={mdiChevronUp} size={1} />
        ) : (
          <Icon path={mdiChevronDown} size={1} />
        )}
      </div>
      <Collapse
        in={openList === "brand"}
        timeout="auto"
        unmountOnExit
        className='mt-3'
      >
        <FormGroup>
          <FormControlLabel control={<Checkbox />} label="پرسا" />
          <FormControlLabel control={<Checkbox />} label="جوسرا" />
          <FormControlLabel control={<Checkbox />} label="دکتر کلادر" />
          <FormControlLabel control={<Checkbox />} label="رویال کنین" />
        </FormGroup>
      </Collapse>
      <div className="d-flex justify-content-between mt-3">
        <Typography>فقط کالاهای موجود</Typography>
        <Switch color="secondary" />
      </div>
    </div>
  )
}

export default ProductSearch